import { createFileRoute } from '@tanstack/react-router';
import { useT } from '../../i18n';

function SelectRequest() {
  const t = useT();
  return <div className="grid h-full place-items-center p-8 text-center text-graphite"><p>{t.inbox.select}</p></div>;
}
export const Route = createFileRoute('/_app/inbox/')({ component: SelectRequest });
